import { isPast } from 'date-fns';
import { TimelineNode } from '../types';

export const isGanttZoneDroppable = (node: TimelineNode) => isPast(node.endDate);
